module.exports = __webpack_public_path__ + "img/selected1-min.a1b43a8f.png";